<template>
  <div class="loader">
    <div class="overlay" :class="{pageLoad: isPageLoader, noOpacity: isStripeRedirect}"></div>
    <div class="loading">
      <nobr>{{ $t('generic.buttons.loading') }}</nobr>
      <div class="spinner"></div>
    </div>
  </div>
</template>

<script>
import { isStripeRedirect } from '@/utils/stripeRedirect'

export default {
  name: "CiLoader",
  props: {
    isPageLoader: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isStripeRedirect: isStripeRedirect(),
    }
  }
};
</script>

<style lang="scss" scoped>
.loader {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 500;

  .overlay {
    background: #fff;
    height: 100%;
    left: 0;
    opacity: 0.9;
    position: absolute;
    top: 0;
    width: 100%;

    &.pageLoad {
      background-color: #f5f5f5;
      opacity: 0.9; //1
    }

    &.noOpacity {
      opacity: 1;
    }
  }

  .loading {
    @include font('gotham_mediumregular');
    @include font-format(1rem, 1rem);

    background-color: #9b9b9b;
    border-radius: 37.5px;
    color: white;
    left: 50%;
    padding: 15px 65px 15px 30px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);

    @include media-breakpoint-up(md) {
      @include font-format(1.75rem, 1rem);

      padding: 30px 100px 30px 50px;
    }

    .spinner {
      width: 25px;
      height: 25px;
      right: 15px;

      @include media-breakpoint-up(md) {
        width: 40px;
        height: 40px;
        right: 25px;
      }
    }
  }
}
</style>
